import React from 'react';
import PropTypes from 'prop-types';
import { FDBox, FDStack, FDStat } from '@facet-wealth/design';


const StatList = ({ summaryItems }) => {
  return (
    <FDStack alignItems="center" wrap justifyContent="flex-start">
      {summaryItems?.resources().list().map((itemResource) => (
        <FDBox width="200px">
          {itemResource.attr('isHidden') === 'false' ? <FDStat label={itemResource.attr('title')} value={itemResource.attr('value')} /> : null}
        </FDBox>
      ))}
    </FDStack>
  );
};

StatList.defaultProps = {};

StatList.propTypes = {
  summaryItems: PropTypes.object.isRequired,
};

export default StatList;
